/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectActivityResourcePastEventsInnerAuthor
 */
export interface ProjectActivityResourcePastEventsInnerAuthor {
    /**
     * 
     * @type {string}
     * @memberof ProjectActivityResourcePastEventsInnerAuthor
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectActivityResourcePastEventsInnerAuthor
     */
    photoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectActivityResourcePastEventsInnerAuthor
     */
    type: ProjectActivityResourcePastEventsInnerAuthorTypeEnum;
}


/**
 * @export
 */
export const ProjectActivityResourcePastEventsInnerAuthorTypeEnum = {
    User: 'USER',
    Admin: 'ADMIN',
    System: 'SYSTEM',
    Unknown: 'UNKNOWN'
} as const;
export type ProjectActivityResourcePastEventsInnerAuthorTypeEnum = typeof ProjectActivityResourcePastEventsInnerAuthorTypeEnum[keyof typeof ProjectActivityResourcePastEventsInnerAuthorTypeEnum];


/**
 * Check if a given object implements the ProjectActivityResourcePastEventsInnerAuthor interface.
 */
export function instanceOfProjectActivityResourcePastEventsInnerAuthor(value: object): value is ProjectActivityResourcePastEventsInnerAuthor {
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ProjectActivityResourcePastEventsInnerAuthorFromJSON(json: any): ProjectActivityResourcePastEventsInnerAuthor {
    return ProjectActivityResourcePastEventsInnerAuthorFromJSONTyped(json, false);
}

export function ProjectActivityResourcePastEventsInnerAuthorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectActivityResourcePastEventsInnerAuthor {
    if (json == null) {
        return json;
    }
    return {
        
        'fullName': json['fullName'],
        'photoUrl': json['photoUrl'] == null ? undefined : json['photoUrl'],
        'type': json['type'],
    };
}

export function ProjectActivityResourcePastEventsInnerAuthorToJSON(value?: ProjectActivityResourcePastEventsInnerAuthor | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fullName': value['fullName'],
        'photoUrl': value['photoUrl'],
        'type': value['type'],
    };
}

